import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'design-system';

const useTextInputStyles = makeStyles({
  defaultCustomInput: {
    borderBottomColor: colors.silver,
    '&:before': {
      borderColor: colors.silver,
    },
    '&:hover:not(.Mui-disabled):before': {
      borderColor: colors.silver,
    },
  },
  correctCustomInput: {
    borderBottomColor: colors.shamrock,
    '&:before': {
      borderColor: colors.shamrock,
    },
    '&:hover:not(.Mui-disabled):before': {
      borderColor: colors.shamrock,
    },
  },
  errorCustomInput: {
    borderBottomColor: colors.bright_pink,
    '&:before': {
      borderColor: colors.bright_pink,
    },
    '&:hover:not(.Mui-disabled):before': {
      borderColor: colors.bright_pink,
    },
  },
});

export default useTextInputStyles;
